declare const __CODEX_WORKSPACE_APP_VARIANT__: string | undefined;
declare const __CODEX_WORKSPACE_LOCAL_FAST_IMPORT_BUILD__: boolean | undefined;

export type AppBuildVariant = 'standard' | 'local-fast';

const normalizeAppBuildVariant = (value?: string | null): AppBuildVariant =>
  value === 'local-fast' ? 'local-fast' : 'standard';

const isLocalFastImportBuild =
  typeof __CODEX_WORKSPACE_LOCAL_FAST_IMPORT_BUILD__ === 'boolean'
    ? __CODEX_WORKSPACE_LOCAL_FAST_IMPORT_BUILD__
    : false;

export const APP_BUILD_VARIANT: AppBuildVariant = normalizeAppBuildVariant(
  isLocalFastImportBuild
    ? 'local-fast'
    : typeof __CODEX_WORKSPACE_APP_VARIANT__ === 'string'
      ? __CODEX_WORKSPACE_APP_VARIANT__
      : null,
);

export const IS_LOCAL_FAST_IMPORT_BUILD = APP_BUILD_VARIANT === 'local-fast';
